import { PricingStrategy } from '@wix/ambassador-premium-domains-v1-recommendation/types';
import { Box, Text, Tooltip } from '@wix/design-system';
import { DomainSearchSuiteModule, ModalsModule, PricingContent } from '@wix/domains-search-suite';
import { InfoCircleSmall } from '@wix/wix-ui-icons-common/odeditor';
import React from 'react';
import VoucherTldListIcon from '../../../assets/images/VoucherTldList.svg';
import { useIsMobile } from '../../../hooks/useIsMobile';
import s from './tldListPricing.module.scss';
const PRICE_KEY = 'domain_search_suite.domain_gate.suggestions.card.domain_price';
const LABEL_KEY = 'domain_search_suite.business_email_results.intro_price.label';
const TOOLTIP_KEY = 'domain_search_suite.results.intro_price.tooltip';
export const TLD_LIST_PRICE_INFO_HOOK = 'tld-list-price-info';
const INTRO_OFFER_ROWS = {
  [PricingStrategy.FREE_FIRST_YEAR]: {
    priceFrom: 'originalPrice',
    strikethroughFrom: 'renewalPrice'
  },
  [PricingStrategy.FIRST_YEAR_MINOR_UNIT]: {
    priceFrom: 'price',
    strikethroughFrom: 'renewalPrice'
  },
  [PricingStrategy.MULTI_YEAR_MINIMUM_COUNT]: {
    priceFrom: 'price',
    strikethroughFrom: 'originalPrice'
  }
};
export const TldListPricingContent = props => {
  const _DomainSearchSuiteMod = DomainSearchSuiteModule.internals.useTranslations(),
    t = _DomainSearchSuiteMod.t;
  const isMobile = useIsMobile();
  const pricing = props.pricing,
    domainName = props.domainName;
  const row = pricing != null && pricing.pricingStrategy ? INTRO_OFFER_ROWS[pricing.pricingStrategy] : undefined;
  const price = row && pricing[row.priceFrom];
  const strikethrough = row && pricing[row.strikethroughFrom];
  if (!price || !strikethrough) {
    return /*#__PURE__*/React.createElement(PricingContent, props);
  }
  if (price === strikethrough) {
    return /*#__PURE__*/React.createElement(Text, {
      size: "medium",
      weight: "normal"
    }, t(PRICE_KEY, {
      domainPrice: price
    }));
  }
  const renewalCopy = t(TOOLTIP_KEY, {
    price: pricing.renewalPrice
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    direction: "horizontal",
    gap: "0 SP1",
    verticalAlign: "bottom",
    flexWrap: "wrap"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "normal",
    secondary: true,
    light: true,
    className: s.struck
  }, t(PRICE_KEY, {
    domainPrice: strikethrough
  })), /*#__PURE__*/React.createElement(Text, {
    size: "medium",
    weight: "normal"
  }, t(PRICE_KEY, {
    domainPrice: price
  })), isMobile ? /*#__PURE__*/React.createElement(InfoCircleSmall, {
    className: s.infoIcon,
    "data-hook": TLD_LIST_PRICE_INFO_HOOK,
    onClick: event => {
      event.stopPropagation();
      ModalsModule.internals.domainsSharedModalsController.infoModal.show({
        title: /*#__PURE__*/React.createElement(Text, {
          size: "medium",
          weight: "bold"
        }, domainName),
        content: /*#__PURE__*/React.createElement(Text, {
          size: "small",
          weight: "thin"
        }, renewalCopy)
      });
    }
  }) : /*#__PURE__*/React.createElement(Tooltip, {
    content: renewalCopy,
    maxWidth: "250px",
    appendTo: "scrollParent",
    placement: "bottom"
  }, /*#__PURE__*/React.createElement(Box, {
    verticalAlign: "middle"
  }, /*#__PURE__*/React.createElement(InfoCircleSmall, {
    className: s.infoIcon,
    "data-hook": TLD_LIST_PRICE_INFO_HOOK
  })))), /*#__PURE__*/React.createElement(Box, {
    direction: "horizontal",
    verticalAlign: "middle",
    gap: "4px",
    className: s.introOffer
  }, /*#__PURE__*/React.createElement(VoucherTldListIcon, null), /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "bold"
  }, t(LABEL_KEY))));
};
//# sourceMappingURL=TldListPricingContent.js.map